<template>

	<div>
		<el-table
			:data="partsData"
			stripe
			style="width: 100%"
			header-cell-style = "background-color: #f2f5f9; height: 48px; text-align: center;"
		>
			<slot></slot>
		</el-table>
		<div v-if="show_add" class="btn-add flex alignC flexC mar-t-12" @click="_btn_add"><img class="wh-16 mar-r-5" src="../../assets/img/add.png" />添加</div>
	</div>
</template>

<script>
	import {
		defineComponent
	} from "vue";
	export default defineComponent({
		name: 'editlist',
		props: {
			partsData:{
				type: Array,
				required: true,
			},
			show_add: {
				tyle: Boolean,
				default: true
			}
		},
		data() {
			return {
				
			};
		},
		mounted() {

		},
		methods: {
			
			_btn_add(){
				this.$emit('btn_add', '这是我暴露出去的数据', '这是我暴露出去的数据2')
				
				// this.tableData.push({
				// 	id: this.tableData.length + 1,
				// 	name: '123',
				// 	specification: '123',
				// 	mountings_type_pname: '123',
				// 	mountings_brand_name: '123',
				// 	unit_price: '123',
				// 	purchaseunit: '123',
				// 	quantity: '123'
				// })
			}
		},
	});
</script>

<style scoped lang="scss">
.wh-24{
	width: 24px;
	height: 24px;
}
.wh-16{
	width: 16px;
	height: 16px;
}
.btn-add{
	height: 48px;
	border: 1px dashed #f03037;
	border-radius: 4px;
	width: 100%;
	font-weight: 500;
	color: #f03037;
}
</style>
